import Button from '@components/Button';
import Icon from '@components/Icon';
import get from 'lodash/get';
import React from 'react';

import I18n from '../../i18n';
import AppContext from '../../services/Context';
import styled from '../../styled-components';

type PropType = {
  name: string;
  label?: string;
  placeholder?: string;
  value?: any;
  optionLabel: string;
  optionValue: string;
  items: any;
  multiple?: boolean;
  withError?: boolean;
  multipleSeparator?: string;
  anchor?: string;
  emptyMessage?: string;
  addorn?: any;
  hideClearButton?: boolean;
  disabled?: boolean;
  displayTemplate?: Function;
  setFieldValue: Function;
  setTouched: Function;
  onFocus: Function;
  onBlur: Function;
};

type StateType = { isOpen: boolean };

class Dropdown extends React.Component<PropType, StateType> {
  state = { isOpen: false };

  wrapperRef: any;

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef = (node: any) => (this.wrapperRef = node);

  handleClickOutside = (e: any) => {
    if (this.wrapperRef && !this.wrapperRef.contains(e.target) && !!this.state.isOpen) {
      this.toggleDropdown();
    }
  };

  toggleDropdown = () => this.setState({ isOpen: !this.state.isOpen });

  selectItem = (option: any) => {
    const { name, value, optionValue, setFieldValue, setTouched, multiple } = this.props;
    const nextValue = option[optionValue];
    let submitValue = null;

    if (!!multiple) {
      if (typeof value === 'string') {
        submitValue = [nextValue];
      } else {
        const valueIndex = value.indexOf(nextValue);
        if (valueIndex > -1) {
          submitValue = value.splice(valueIndex, 1);
        } else {
          value.push(nextValue);
        }
        submitValue = [...value];
      }
    } else {
      submitValue = nextValue;
    }

    setFieldValue(name, submitValue);
    setTouched({ [name]: true });

    if (!multiple) this.toggleDropdown();
  };

  clearSelection = () => {
    const { name, setFieldValue } = this.props;
    setFieldValue(name, '');
  };

  getDisplayValue = (dataSet: any, optionValue: string, selected: string | any) => {
    let filtered: any = [];

    if (typeof selected === 'string') {
      if (selected && selected.length > 0) {
        filtered = dataSet.filter((item: any) => item[optionValue] === selected);
      }
      return filtered.length > 0 ? filtered[0] : {};
    }

    dataSet.map((item: any) => {
      if (selected.includes(item[optionValue])) {
        filtered.push(item);
      }
      return null;
    });
    return filtered;
  };

  displayMultipleValues = (values: any) => {
    const { optionLabel, multipleSeparator } = this.props;
    const valuesList = [];

    for (const key in values) {
      if (values.hasOwnProperty(key)) {
        const item = values[key];
        valuesList.push(item[optionLabel]);
      }
    }

    return valuesList.join(multipleSeparator || ', ');
  };

  renderOptions = (items: any[]) => {
    const { value, optionLabel, optionValue, multiple } = this.props;

    // GAMBS: essa gambiarra ocorre quando o objeto feedado para o dropdown não é um conjunto de chave-valor, mas sim um array de items
    // O CORRETO seria tratar ambos os casos, e não transformar o objeto, mas o comportamento de todos os dropdowns do sistema pode ser comprometido
    // já que nenhum desses componentes de componentes de componentes trata exceptions corretamente. Eis, portanto, a gambiarra
    if (typeof items[0] === 'string') {
      const newItems: object[] = [];
      items.forEach(element => {
        newItems.push({
          value: element,
          label: element
        });
      });

      items = newItems;
    };

    return items.map(item => {
      let complementClassName = '';
      if (!!multiple && typeof value !== 'string' && value.indexOf(item[optionValue]) > -1) {
        complementClassName = ' active';
      }

      return (
        <Item
          key={item[optionValue] ? `item-${item[optionValue]}` : `group-${item[optionLabel]}`}
          className={item.className + complementClassName}
          onClick={() => (!item.className || item.className !== 'father') && this.selectItem(item)}
        >
          {item[optionLabel]}
        </Item>
      );
    });
  };

  render() {
    const {
      items,
      value,
      // placeholder, // TODO: create placeholder
      optionLabel,
      optionValue,
      disabled,
      multiple,
      anchor,
      displayTemplate,
      addorn,
      emptyMessage,
      hideClearButton,
    } = this.props;
    const { isOpen } = this.state;
    const buttonIcon = !!isOpen ? 'chevron-up' : 'chevron-down';
    const dataSet: any = [];
    items.map((item: { type: string; items: any[] }) => {
      if (item.type && item.type === 'group') {
        dataSet.push({ label: item[optionLabel], className: 'father' });
        item.items.map(child => dataSet.push({ ...child, className: 'child' }));
      } else {
        dataSet.push(item);
      }
      return item;
    });
    const listCount: number = dataSet.length;
    const displayValue: any = this.getDisplayValue(dataSet, optionValue, value);

    return (
      <AppContext.Consumer>
        {({ theme, locale }) => (
          <InputWrapper innerRef={comp => (this.wrapperRef = comp)}>
            {addorn &&
              addorn.leftIcon && (
                <Addorn theme={theme} className={disabled ? 'disabled' : ''}>
                  <Icon name={addorn.leftIcon} />
                </Addorn>
              )}
            {addorn &&
              addorn.left && (
                <Addorn theme={theme} className={disabled ? 'disabled' : ''}>
                  {addorn.left}
                </Addorn>
              )}
            <Display theme={theme} onClick={this.toggleDropdown}>
              {displayTemplate
                ? displayTemplate(displayValue)
                : !!multiple
                  ? this.displayMultipleValues(displayValue)
                  : displayValue[optionLabel]}
            </Display>
            {!hideClearButton &&
              value && (
                <Button
                  icon={{ name: 'times-circle' }}
                  onClick={(event: any) => {
                    event.preventDefault();
                    this.clearSelection();
                  }}
                />
              )}
            <Button
              icon={{ name: buttonIcon }}
              disabled={disabled}
              className="link"
              onClick={(event: any) => {
                event.preventDefault();
                if (event.detail !== 0) {
                  this.toggleDropdown();
                }
              }}
            />
            {!!isOpen && (
              <DropdownWrapper className={`anchor-${anchor || 'bottom'}`}>
                {listCount > 0 && <List count={listCount}>{this.renderOptions(dataSet)}</List>}
                {listCount === 0 && (
                  <List count={listCount} className="empty">
                    {emptyMessage || I18n.l('form.dropdown.empty')}
                  </List>
                )}
              </DropdownWrapper>
            )}
          </InputWrapper>
        )}
      </AppContext.Consumer>
    );
  }
}

const InputWrapper = styled.div.attrs({
  className: `form-select-wrapper`,
})`
  background: #fff;
  border-radius: 12px;
  display: flex;
  flex-flow: row nowrap;
  position: relative;
  height: 37px;
  width: 100%;
  z-index: 9;

  input {
    cursor: pointer;
  }
`;

const Display = styled.div.attrs({
  className: `select-dropdown-display`,
})`
  cursor: pointer;
  flex: 1;
  ${({ theme }) => get(theme, 'form.localeChange.display')};
`;

const DropdownWrapper = styled.div.attrs({
  className: `select-dropdown-wrapper`,
})`
  background: #fff;
  display: flex;
  border: 1px solid #ddd;
  border-radius: 12px;
  overflow: hidden;
  position: absolute;
  left: 0;
  min-width: 150px;
  width: 100%;
  z-index: 9;

  &.anchor-top {
    bottom: 38px;
  }
  &.anchor-bottom {
    top: 38px;
  }
`;

const List = styled.ul.attrs({
  className: `form-select-list`,
})`
  margin: 0;
  height: auto;
  overflow-y: ${({ count }: any) => (count > 4 ? `scroll` : 'hidden')};
  max-height: 200px;
  min-width: 100%;
  padding: 0;
  z-index: 9;
  

  &.empty {
    font-size: 0.9rem;
    font-style: italic;
    height: auto;
    overflow-y: auto;
    opacity: 0.8;
    padding: 5px 0;
    text-align: center;
  }
`;

const Item = styled.li`
  cursor: pointer;
  list-style: none;
  padding: 5px 10px;
  text-align: justify;
  margin: 0 22px;  
  &.child {
    padding-left: 20px;
  }

  &.active {
    background: #ddd;

    &:hover {
      background: #ddd;
    }
  }

  &:hover {
    background: #f2f2f2;
  }

  &.father {
    font-weight: bolder;

    &:hover {
      background: #fff;
    }
  }
`;

const Addorn = styled.span`
  flex: 0;
  padding: 10px 0px;
  text-align: center;

  &.disabled {
    background: #f2f2f2;
    color: #888;
  }
`;

export default Dropdown;
